var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({},_vm.events),[_c('component-wrapper',{staticStyle:{"max-width":"100%"},attrs:{"config":_vm.component}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }